import React, { useState } from "react";
import axios from "axios";
import { Cookies } from "react-cookie";
import Loading from "../Loading";
import { ErrorAlert, SuccessAlert } from "../middleware/AlertMsg";
import { useLocation } from "react-router-dom";
import "./TransferRequest.css";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
} from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'
const SingleTransferRequest = () => {
  const cookies = new Cookies();
  const token = cookies.get("JWTcookie");
  const location = useLocation();
  const dataReceived = location.state;
  //   console.log(dataReceived._id);
  const [isLoading, setLoading] = useState(false);
  const baseUrl =process.env.REACT_APP_BASE_URL;
  //const baseUrl = "https://officejeeves.com";
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
  const acceptTransferStock = async (id) => {
    const shouldDelete = window.confirm("Are you sure ?");
    if (!shouldDelete) {
      return;
    }
    setLoading(true);
    const checkid = dataReceived._id;
    if (checkid) {
      const res = await axios.post(
        `${baseUrl}/api/acceptStockTransferRequest/${checkid}`,
        {},
        { headers: { Authorization: "Bearer " + token } }
      );
      // console.log("res", res);
      if (res.data.success) {
        setLoading(false);
        SuccessAlert({
          title: "Success",
          message: "Request accepted",
        });
      } else {
        ErrorAlert({
          title: "Fail",
          message: "Request not accepeted",
        });
        setLoading(false);
      }
    }
  };

  return (
    <React.Fragment>
      {isLoading ? (
        // <Loading />
        <tr>
          <td colSpan="6">
            <Loading />
          </td>
        </tr>
      ) : (
        <div className="main">
          <div className="details-container">
            <div className="details">
              <span className="detail-label">From Warehouse:</span>
              <span className="detail-value">
                {dataReceived?.fromWarehouse}
              </span>
            </div>

            <div className="details">
              <span className="detail-label">To Warehouse:</span>
              <span className="detail-value">{dataReceived?.toWarehouse}</span>
            </div>

            <div className="details">
              <span className="detail-label">Status:</span>
              <span className="detail-value">{dataReceived?.status}</span>
            </div>

            <div className="details">
              <span className="detail-label">Created At:</span>
              <span className="detail-value">{dataReceived?.createdAt}</span>
            </div>
          </div>

          <div className="products">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
               <StyledTableRow>
                  <HeaderTableCell>S.No.</HeaderTableCell>
                  <HeaderTableCell>Product name</HeaderTableCell>
                  <HeaderTableCell>Product Qty</HeaderTableCell>
                </StyledTableRow>
              </TableHead>

              <TableBody>
                {dataReceived?.products?.map((items, i) => (
                  <StyledTableRow key={items.id} sx={{
                    backgroundColor: i % 2 === 0 ? '#f5f5f5' : 'white',
                  }}>
                    <StyledTableCell align='center'> {i + 1} </StyledTableCell>
                    <StyledTableCell> {items?.productName} </StyledTableCell>
                    <StyledTableCell align='right'> {items?.productQuantity} </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          </div>

          <div className="button-container">
            {dataReceived?.status === "Pending" ? (
              <button className="accept-button" onClick={acceptTransferStock}>
                Accept
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default SingleTransferRequest;
